/*------------------------------------*/
/*------ ハンバーガーメニューの処理 ------*/
/*------------------------------------*/
$(".openbtn").on("click", function () {
    $(this).toggleClass('active');
    $(".add-menu-drawer").toggleClass('active');
    $(".nav-wrap").toggleClass('active');
    $(".header-wrap").toggleClass('active');
    $(".bg-black").toggleClass('active');
});

$(".bg-black").on("click", function () {
    $(this).toggleClass('active');
    $(".add-menu-drawer").toggleClass('active');
    $(".nav-wrap").toggleClass('active');
    $(".header-wrap").toggleClass('active');
    $(".openbtn").toggleClass('active');
});


/*-------------------------------------*/
/*------ ロード完了時のアニメーション ------*/
/*-------------------------------------*/

$(window).on('load', function () {
    $('#loading').addClass('loaded');
});

/* ブラウザバック時にonloadが発火しない問題 */
window.addEventListener('pageshow', function () {
    $('#loading').addClass('loaded');
});


/*-------------------------------------*/
/*------ 画面遷移前のアニメーション ------*/
/*-------------------------------------*/

/*
$(window).on("beforeunload", function () {
    $('#loading').removeClass('loaded');
});
*/

// safariがbeforeunload効かない問題
/*
var ua = window.navigator.userAgent.toLowerCase();
if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) {
    $(window).on("pagehide", function () {
        $('#loading').removeClass('loaded');
    });
}
*/
/*
$('a').on('click', function () {
    event.preventDefault();
    var link = $(this).attr('href');
    $('#loading').removeClass('loaded');
    setTimeout(function () {
        location.href = link;
    }, 250);
});
*/

$('a').on('click', function (event) {
    var target = $(this).attr('target');
    
    // target="_blank"の場合は通常の動作を行わない
    if (target === '_blank') {
        return;
    }

    event.preventDefault();
    var link = $(this).attr('href');
    $('#loading').removeClass('loaded');
    setTimeout(function () {
        location.href = link;
    }, 250);
});



/*---------------------------------------*/
/*------ 下層ページFVの文字ぼかしの処理 ------*/
/*---------------------------------------*/

$(window).on('load', function () {
    setTimeout(function () {
        $('.sub-fv-wrapper .title h2').addClass('active');
    }, 500);
});


/*----------------------------*/
/*------ 通常FadeInの処理 ------*/
/*----------------------------*/

$(function () {
    $(window).scroll(function () {
        $('.fadein').each(function () {
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > position - windowHeight + 140) {
                $(this).addClass('active');
            }
        });
    });

    $(window).on('load', function () {
        $('.fadein').each(function () {
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > position - windowHeight + 140) {
                $(this).addClass('active');
            }
        });
    });
});


/*--------------------------------*/
/*------ ディレイFadeInの処理 ------*/
/*--------------------------------*/

  function fadeInElements() {
    $('.d-fadein').each(function (i) {
      let delay = 100;
      var position = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > position - windowHeight + 80) {
        $(this).delay(i * delay).queue(function (next) {
          $(this).addClass('active');
          next();
        });
      }
    });
  }

  // ロード時の処理
  $(document).ready(function() {
    fadeInElements();
  });

  // スクロール時の処理
  $(window).scroll(function() {
    fadeInElements();
  });

  

/*-------------------------------------------*/
/*------ ディレイFadeInの処理（ヘッダー用） ------*/
/*-------------------------------------------*/

$(".openbtn, .bg-black").on("click", function () {
    const anyActive = $('.h-fadein.active').length > 0;
  
    $('.h-fadein').each(function (i) {
        let delay = 100;
        if (anyActive) {
            $(this).removeClass('active');
        } else {
            $(this).delay(i * delay).queue(function (next) {
                $(this).addClass('active');
                next();
            });
        }
    });
});
